import styled from 'styled-components';
// FIXME: Replace components by new components
import { Avatar } from 'apps/components/shared';
import { customMedia } from 'styles/utils';

export const Wrapper = styled.div`
  /* Media queries */
  ${customMedia.lessThan('large')`
    display: none;
  `}
`;

export const AvatarStyled = styled(Avatar)`
  margin: 0 ${props => props.theme.spacing.xsmall};
`;
